import { motion } from "framer-motion";
import { LINKS } from "../../data/content";

export const FinalCTA = () => (
  <section className="bg-zinc-950 py-20 md:py-28" data-testid="final-cta-section">
    <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="font-heading font-black text-3xl md:text-5xl tracking-tight text-white">
          Descoperă tot ce poți face cu <span className="text-brand">BRD-ISIC</span>
        </h2>
        <p className="mt-6 text-base md:text-lg text-zinc-400 leading-relaxed max-w-2xl mx-auto">
          Ai deja un card creat pentru viața de elev sau student. Explorează reducerile tale
          și ține legitimația la îndemână în Alive App.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href={LINKS.discountsRo}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-discounts"
            className="inline-flex items-center rounded-full bg-brand px-8 py-3.5 text-base font-semibold text-white shadow-lg shadow-brand/25 hover:bg-brand-dark hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
          >
            Vezi reducerile
          </a>
          <a
            href="#alive-app"
            data-testid="final-cta-alive"
            className="inline-flex items-center rounded-full border-2 border-zinc-700 px-8 py-3.5 text-base font-semibold text-white hover:border-brand hover:text-brand transition-colors duration-300"
          >
            Descarcă Alive App
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="bg-zinc-950 border-t border-zinc-800 py-10" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-5 md:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
      <p className="text-sm text-zinc-500">
        Dacă ai orice întrebare, scrie-ne la{" "}
        <a href="mailto:vreau@isic.ro" data-testid="footer-email-link" className="text-brand hover:underline">
          vreau@isic.ro
        </a>
      </p>
      <p className="text-xs text-zinc-600">© {new Date().getFullYear()} ISIC România</p>
    </div>
  </footer>
);
